<template>
  <img
    :src="resolvedSrc"
    :alt="altText"
    class="login-brand-logo"
    :class="logoClass"
    decoding="async"
  />
</template>

<script setup>
import { computed } from 'vue'
import { resolveLoginBrandLogo } from '@/utils/loginBrandAssets'

defineOptions({ name: 'LoginBrandLogo' })

const props = defineProps({
  isDark: {
    type: Boolean,
    default: true,
  },
  orgLogoUrl: {
    type: String,
    default: null,
  },
  title: {
    type: String,
    default: 'Yandle',
  },
  /** full wordmark | mark icon | org (auto when orgLogoUrl set) */
  variant: {
    type: String,
    default: 'full',
    validator: (v) => ['full', 'mark', 'org'].includes(v),
  },
})

const resolvedSrc = computed(() =>
  resolveLoginBrandLogo({
    isDark: props.isDark,
    orgLogoUrl: props.orgLogoUrl,
    variant: props.variant === 'org' ? 'full' : props.variant,
  }),
)

const altText = computed(() => `${props.title} logo`)

const logoClass = computed(() => {
  if (props.orgLogoUrl) {
    return `login-brand-logo--${props.variant === 'mark' ? 'mark' : 'org'}`
  }
  return `login-brand-logo--${props.variant}`
})
</script>
